import React, { createContext, FC } from 'react'

type IClosePopoversProvider = () => void

interface ClosePopoversProviderProps {
	readonly onClose: (event?: any) => void
	readonly children?: React.ReactNode
}

export const ClosePopoversContext = createContext<IClosePopoversProvider>(
	() => {}
)

const ClosePopoversProvider: FC<ClosePopoversProviderProps> = ({
	onClose,
	children,
}: ClosePopoversProviderProps) => {
	return (
		<ClosePopoversContext.Provider value={onClose}>
			{children}
		</ClosePopoversContext.Provider>
	)
}

export default ClosePopoversProvider
